import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  icon: {
    width: '40px',
    height: '40px',
    cursor: 'pointer',
  },
  rotatingIcon: {
    animation: 'rotate 1s infinite linear',
    color: 'rgba(94, 186, 0, 0.74)',
    width: '40px',
    fontSize: '30px',
  },
  timerText: {
    marginRight: theme.spacing(0.5),
    width: '95px',
  },
}));
